import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';
import { ConfigState } from '../states/config.state';

export const selectConfigFeature = (state: AppState) => state.config;

export const selectConfig = createSelector(
  selectConfigFeature, (state: ConfigState) => state
)
